import { QuizVersion } from '../../../config/types'

type QuizRouteConfig = {
  quizVersion: QuizVersion
  routeBase: string
}

export const getQuizRouteConfig = (pathname: string): QuizRouteConfig => {
  let quizVersion: QuizVersion = 'e4'
  if (pathname.startsWith('/menoscale')) quizVersion = 'menoscale'
  else if (pathname.startsWith('/e12')) quizVersion = 'e12'
  else if (pathname.startsWith('/guest-pass')) quizVersion = 'guest-pass'
  else if (pathname.startsWith('/e11')) quizVersion = 'e11'
  else if (pathname.startsWith('/e10')) quizVersion = 'e10'
  else if (pathname.startsWith('/e9')) quizVersion = 'e9'
  else if (pathname.startsWith('/e8')) quizVersion = 'e8'
  else if (pathname.startsWith('/e7')) quizVersion = 'e7'
  else if (pathname.startsWith('/e6')) quizVersion = 'e6'
  else if (pathname.startsWith('/e5')) quizVersion = 'e5'

  return { quizVersion, routeBase: quizVersion }
}
